<template>
  <div>
    <b-modal
      size="lg"
      ref="modal_verifica_cancelamento"
      class="border-r-5"
      header-class="hidden"
      body-class="fundo-cinza-mix"
      footer-class="px-2 mt-3  no-border"
    >
      <!-- Conteúdo do modal de sucesso -->
      <div class="row">
        <div class="col-12 text-center">
          <b-spinner
            v-if="
              modal_verifica_cancelamento.aceitou &&
              modal_verifica_cancelamento.loading
            "
            label="Carregando..."
          ></b-spinner>

          <div class="row px-3">
            <div class="col-12">
              <button
                @click="$refs.modal_verifica_cancelamento.hide()"
                class="close texto-escuro"
                aria-label="Fechar"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="col-12 text-left">
              <h2 v-if="modal_verifica_cancelamento.principal === '1'" style="color: white">Pensando em partir? ☹</h2>
              <h2 v-if="modal_verifica_cancelamento.principal === '0'" style="color: white">Confirmação de Cancelamento</h2>
            </div>
            <div class="col-12 text-left mb-2 mt-4">
              <span  v-if="modal_verifica_cancelamento.principal === '1'" class="texto-branco" style="font-family: 'roboto-light'"
                >Sabemos que cada decisão é única, mas adoraríamos entender se
                há algo que podemos fazer para melhorar sua experiência
                conosco.</span
              >
              <span class="texto-branco"  v-if="modal_verifica_cancelamento.principal === '0'" style="font-family: 'roboto-light'"
                >Entendemos sua decisão de ajustar os adicionais. E justamente essa flexibilidade que torna nosso sistema único: você tem a liberdade de moldar o plano conforme suas necessidades.</span
              >
            </div>
            <div class="col-12 text-left mt-3">
              <div class="row" v-if="modal_verifica_cancelamento.principal === '1'">
                <div class="col-9 text-left">
                  <ul>
                    <li
                      class="texto-branco"
                      style="font-family: 'roboto-light'"
                    >
                      Lembre-se que você pode alternar para o plano gratuito
                      sem a necessidade de excluir sua conta.
                    </li>
                  </ul>
                </div>
                <div class="col-3">
                  <button @click="alterarPlano" style="width: 100%" class="btn btn-customizado btn-customizado-branco">
                    Alterar Plano
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-9 text-left">
                  <ul>
                    <li
                      class="texto-branco"
                      v-if="modal_verifica_cancelamento.principal === '1'"
                      style="font-family: 'roboto-light'"
                    >
                      Buscando recursos adicionais? Explore nossa página
                      "Mercado" e descubra mais ferramentas.
                    </li>
                    <li
                      class="texto-branco"
                      v-if="modal_verifica_cancelamento.principal === '0'"
                      style="font-family: 'roboto-light'"
                    >
                      Convidamos você a explorar o mercado e descobrir outros
                      adicionais que possam se encaixar melhor em sua rotina atual.
                    </li>
                  </ul>
                </div>
                <div class="col-3">
                  <router-link
                    :to="{ name: 'mercado' }"
                    style="width: 100%"
                    class="btn btn-customizado btn-customizado-branco"
                  >
                    Mercado
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-12 mb-3 text-left">
              <span class="texto-branco" v-if="isVencido && modal_verifica_cancelamento.principal === '1'" style="font-family: 'roboto-light'">Encontrou alguma dificuldade? Compartilhe conosco; sua opinião é essencial para aprimorar nossos serviços. O cancelamento vai ser <b class="texto-branco">imediato</b>.<br></span>
              <span class="texto-branco" v-if="!isVencido && modal_verifica_cancelamento.principal === '1'" style="font-family: 'roboto-light'">Encontrou alguma dificuldade? Compartilhe conosco; sua opinião é essencial para aprimorar nossos serviços. Mesmo após o cancelamento, você continuará tendo acesso à plataforma até o dia <b class="texto-branco">{{ contrato.data_vencimento_por_extenso }}</b>.<br></span>
              <span class="texto-branco" v-if="modal_verifica_cancelamento.principal === '0'" style="font-family: 'roboto-light'">Encontrou alguma dificuldade? Compartilhe conosco; sua opinião é essencial para aprimorar nossos serviços. Mesmo após o cancelamento, você continuará com o adicional ativo até o dia <b class="texto-branco">{{ contrato ? contrato.data_vencimento_por_extenso : null }}</b>.<br></span>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="row px-3">
          <div class="col-12">
            <div class="row align-items-center">
              <div class="col-9">
                <span class="texto-cinza" v-if="modal_verifica_cancelamento.principal === '1'" style="font-family: 'roboto-light'">Se ainda desejar prosseguir com o cancelamento, clique no botão abaixo. Lembre-se de que estamos sempre aqui, prontos para recebê-lo de volta.</span>
                <span class="texto-cinza" v-if="modal_verifica_cancelamento.principal === '0'" style="font-family: 'roboto-light'">Para prosseguir com o cancelamento do adicional <b style="font-family: 'roboto-regular';">{{ produto_nome }}</b>, clique no botão ao lado.</span>
              </div>
              <div class="col-3">
                <button
                style="width: 100%"
                  v-if="modal_verifica_cancelamento.principal === '1'"
                  @click="
                    verificarCancelamento(
                      modal_verifica_cancelamento.contrato_id
                    )
                  "
                  :title="
                    !aceitou
                      ? 'Tem que aceitar o campo abaixo.'
                      : 'Cancelar Plano'
                  "
                  class="btn btn-customizado btn-customizado-cinza-outline"
                  :disabled="!aceitou || modal_verifica_cancelamento.loading"
                >
                  Cancelar plano
                </button>
                <button
                style="width: 100%"
                  v-if="modal_verifica_cancelamento.principal === '0'"
                  @click="
                    verificarCancelamento(
                      modal_verifica_cancelamento.contrato_id
                    )
                  "
                  class="btn btn-customizado btn-customizado-cinza-outline"
                  :disabled="modal_verifica_cancelamento.loading"
                >
                  Cancelar adicional
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3 mt-3">
            <label
              class="texto-cinza"
              v-if="modal_verifica_cancelamento.principal === '1'"
            >
              <input type="checkbox" v-model="aceitou" required />
              Incluir o cancelamento dos adicionais
            </label>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ModalVerificaCancelamento from './js/modal-verifica-cancelamento'
export default ModalVerificaCancelamento
</script>

<style scoped>
@import "./scss/contratos.scss";
</style>
